













































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { isNull } from 'lodash';

import PaginationInterface from '@core/interfaces/pagination-interface';
import { MembershipCategory } from '@subscriptions/interfaces/subscription-category';
import { BPCDisplayConfig } from '@core/interfaces/bpc-display-config';
import { subscriptionCategoryFilters } from '@/config/subscriptions';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';

import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import TableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import GridMock from '@shared/components/mocks/grid-mock/grid-mock.vue';

import MembershipCategoryCard from '@subscriptions/components/cards/admin/membership-category-card.vue';

import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';

import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import MembershipCategoryForm from '@subscriptions/components/forms/admin/membership-category-form.vue';
import moment from 'moment';

@Component({
  name: 'bpc-membership-categories-list',
  components: {
    'bpc-content-wrapper': ContentWrapper,
    'bpc-table-wrapper': TableWrapper,
    'bpc-grid-mock': GridMock,
    'bpc-membership-category-card': MembershipCategoryCard,
    'bpc-entity-select': EntitySelect,
    'bpc-multi-select': MultiSelect,
    'bpc-search-input': SearchInput,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-membership-category-form': MembershipCategoryForm,
  },
})
export default class MembershipCategoriesList extends Vue {
  declare $refs: {
    softDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
  };
  // PROPS

  // TODO Add ordering
  // @PropSync('orderDirection', { type: String }) syncedOrderDirection!: string;
  // @PropSync('orderBy', { type: String }) syncedOrderBy!: string;
  @Prop({ type: Object }) readonly initialFilters: {
    search: string;
    season_id: number;
    status: string;
  };
  @Prop({ type: String }) readonly actionsPortalTarget: string;

  // DATA

  loading: boolean = false;
  urlParams: Record<string, string> = {};
  config: BPCDisplayConfig = null;
  membershipCategoryItems: MembershipCategory[] = [];

  submittedSearch = '';
  selectedPeriods = [];
  selectedStatus = '';

  pageOptions: number[] = [5, 10, 15, 20, 50, 100, 200];
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    from: 0,
    to: 0,
    total: 0,
  };

  gridCols: object = {
    sm: 12,
    md: 6,
    lg: 4,
  };

  showDrawerSection = false;
  formModel: MembershipCategory = null;
  timestamp = moment().unix();

  // LIFECYCLE

  // created() {}
  mounted() {
    this.initializeFiltersFromProperties();
    this.initializeValuesFromUrlParams();
    this.getMembershipCategoriesIfStopChanging();
  }
  // updated(){}
  // destroyed(){}

  // COMPUTED
  get formCancelPortalTarget(): string {
    return `membership-category-form-cancel-portal-target-${this.timestamp}`;
  }

  get formActionsPortalTarget(): string {
    return `membership-category-form-actions-portal-target-${this.timestamp}`;
  }

  get filtersConfig() {
    return subscriptionCategoryFilters;
  }

  get changeDetectorStr(): string {
    return [
      this.pagination.per_page,
      this.pagination.current_page,
      this.submittedSearch,
      ...this.selectedPeriods,
      this.selectedStatus,
    ].join('--');
  }

  get noLabel() {
    // TODO initialize correctly the "for" attribute in field-wrapper
    return {
      labelAttributes: {
        for: 'test',
      },
    };
  }

  get softDeleteConfirmationModalConfig(): ConfirmationModalConfig {
    const entityName = 'membership-category';
    return {
      id: entityName + '-soft-delete-modal',
      title: this.$t('global.modals.soft-delete.title', {
        entityName: this.$t('global.models.' + entityName + '.name'),
        entityPluralName: this.$t('global.models.' + entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + entityName + '.thisPluralName'),
      }),
      body: this.$t('global.modals.soft-delete.body', {
        entityName: this.$t('global.models.' + entityName + '.name'),
        entityPluralName: this.$t('global.models.' + entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + entityName + '.thisPluralName'),
      }) as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.move_to_trash') as string,
      acceptButtonVariant: 'danger',
    };
  }

  // METHODS

  initializeFiltersFromProperties() {
    if (this.initialFilters) {
      this.submittedSearch = this.initialFilters?.search || '';
      this.selectedStatus = this.initialFilters?.status || 'active';
      if (this.initialFilters?.season_id) {
        if (Array.isArray(this.initialFilters?.season_id)) {
          this.selectedPeriods = this.initialFilters?.season_id;
        } else {
          this.selectedPeriods = [this.initialFilters?.season_id];
        }
      } else {
        this.selectedPeriods = [];
      }
    }
  }

  initializeValuesFromUrlParams() {
    const urlParams = this.getUlrParams();
    this.submittedSearch = urlParams?.search || '';
    this.selectedStatus = urlParams?.status || 'active';
    if (urlParams?.season_id) {
      if (Array.isArray(urlParams?.season_id)) {
        this.selectedPeriods = urlParams?.season_id;
      } else {
        this.selectedPeriods = [urlParams?.season_id];
      }
    } else {
      this.selectedPeriods = [];
    }
  }

  getMembershipCategoriesIfStopChanging() {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getMembershipCategories();
      }
    }, 300);
  }

  // First call
  async getMembershipCategories() {
    this.loading = true;
    const params = this.getQueryParams();
    const url = this.$bpcApiRouteHelper.getEntityPath('membership-category');
    const res = await this.$bpcApi.get(url, { params: params }).toPromise();
    this.membershipCategoryItems = res.data.map(item => {
      return {
        ...item,
        total_orders_price: null,
        total_payments_paid: null,
      };
    });
    this.pagination = res.meta;
    this.setUrlParams(params);
    this.getMembershipCategoriesAccounting();
    this.loading = false;
  }

  // Second call (for accounting data)
  async getMembershipCategoriesAccounting() {
    const membershipCategoryItemIds = this.membershipCategoryItems.map(item => item.id);
    const params = {
      ids: membershipCategoryItemIds,
    };
    const url = `${this.$bpcApiRouteHelper.getEntityPath('membership-category')}/accounting`;
    const res = await this.$bpcApi.get(url, { params: params }).toPromise();
    this.membershipCategoryItems = this.membershipCategoryItems.map(item => {
      if (res.data[item.id]) {
        return {
          ...item,
          total_orders_price: res.data[item.id].total_orders_price,
          total_payments_paid: res.data[item.id].total_payments_paid,
        };
      } else {
        return {
          ...item,
          total_orders_price: null,
          total_payments_paid: null,
        };
      }
    });
  }

  getQueryParams() {
    return {
      orderBy: 'name',
      orderDirection: 'asc',
      per_page: this.pagination.per_page,
      page: this.pagination.current_page,
      search: this.submittedSearch,
      period_id: this.selectedPeriods,
      status: this.selectedStatus,
    };
  }

  getUlrParams() {
    const urlQueryParams = JSON.parse(JSON.stringify(this.$route.query), (k, v) => {
      if (!isNaN(v) && !isNull(v)) {
        return parseInt(v);
      }
      return v;
    });
    return {
      ...urlQueryParams,
    };
  }

  setUrlParams(params) {
    this.$router.push({ query: params }).catch(e => {
      return null;
    });
  }

  clickOnReload() {
    this.getMembershipCategoriesIfStopChanging();
  }

  clickOnView(item) {
    const routeName = 'admin-membership-category';
    const tenant = this.$authService.getSelectedTenant();
    return {
      name: routeName,
      params: {
        tenantAlias: tenant.alias,
        id: item.id,
        item: item,
      },
    };
  }

  clickOnCreate() {
    this.showDrawerSection = true;
  }

  clickOnQuickEdit(item) {
    this.formModel = item;
    this.showDrawerSection = true;
  }

  clickOnSoftDelete(item) {
    this.$refs.softDeleteConfirmationModal.onOpenModal(item.id);
  }

  onEntitySaved() {
    this.getMembershipCategoriesIfStopChanging();
  }

  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.getMembershipCategoriesIfStopChanging();
  }

  onCloseModal() {
    this.formModel = null;
    this.showDrawerSection = false;
  }

  // WATCHERS

  @Watch('changeDetectorStr')
  onChangeDetectorStrChange(val) {
    if (val) {
      this.getMembershipCategoriesIfStopChanging();
    }
  }
}
